/**
 * Helpers for the services still backed by fixture data. They resolve after a
 * tiny delay, so components use the same call shape (promise, loading state) a
 * real endpoint has — components never import from src/fixtures directly.
 */
export const fakeDelay = (ms = 150): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms));

/** Deep-ish copy so templates mutating results can't corrupt the fixtures. */
export const clone = <T>(value: T): T => JSON.parse(JSON.stringify(value)) as T;
